var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-circle-lg waves-effect waves-circle waves-float",attrs:{"disabled":_vm.isAutoRefresh,"type":"button"},on:{"click":_vm.refresh}},[_c('i',{staticClass:"material-icons"},[_vm._v("refresh")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb0364da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RefreshButton.vue
// module id = null
// module chunks = 